// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  fetchGetOrderPayByIdPending: false,
  fetchGetOrderPayByIdError: null,
  fetchGetOrderPayByIdSuccess: null,
  fetchGetPaymentPending: false,
  fetchGetPaymentError: null,
  fetchGetPaymentSuccess: null,
  fetchWeChatScanPayPending: false,
  fetchWeChatScanPayError: null,
  fetchWeChatScanPaySuccess: null,
  fetchGetAccessTokenPending: false,
  fetchGetAccessTokenError: null,
  fetchGetAccessTokenSuccess: null,
  fetchAliScanPayPending: false,
  fetchAliScanPayError: null,
  fetchAliScanPaySuccess: null,
  fetchQueryOrderPending: false,
  fetchQueryOrderError: null,
  fetchQueryOrderSuccess: null,
  fetchAddOrderFromCartsPending: false,
  fetchAddOrderFromCartsError: null,
  fetchCcbScanPayPending: false,
  fetchCcbScanPayError: null,
  fetchCcbScanPaySuccess: null,
  fetchAggregatePayPending: false,
  fetchAggregatePayError: null,
  fetchAggregatePaySuccess: null,
  fetchUpdateOrderStatePending: false,
  fetchUpdateOrderStateError: null,
  fetchGetPayTokenPending: false,
  fetchGetPayTokenError: null,
  fetchGetPayTokenSuccess: null,
  fetchGetMaxCouponPricePending: false,
  fetchGetMaxCouponPriceError: null,
  MaxCouponData: null,
  fetchUseCouponPending: false,
  fetchUseCouponError: null,
  UseCouponData: null
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/pay/redux/initialState.js